import { render, staticRenderFns } from "./view-page.vue?vue&type=template&id=1be8b843&scoped=true&"
import script from "./view-page.vue?vue&type=script&lang=js&"
export * from "./view-page.vue?vue&type=script&lang=js&"
import style0 from "./view-page.vue?vue&type=style&index=0&id=1be8b843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be8b843",
  null
  
)

export default component.exports